import { apiSlice } from "../../app/api/apiSlice";

export const BASE_URL = "https://enactobi.honeywellsaas.com/pre-rest-api/v1";
export const DOTNET_BASE_URL = "https://enacto-powerbi.honeywellsaas.com/Enactodev/api";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/authentication/login`,
                method: 'POST',
                body: { ...credentials }
            })
        }),
        logout: builder.mutation({
            query: () => ({
                url: `${BASE_URL}/authentication/logout`,
                method: 'GET',
            })
        }),
        pbiLogin: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/UserLogin`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiReportList: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Report`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiReportListWithFolder: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Report/ReportListWithFolders`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiReportDetails: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/EmbedToken`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiGetTenantDetails: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Tenant/${credentials.loginId}`,
                method: 'GET',
            })
        }),
        pbiGetUserDetails: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/UserProfile?username=${credentials.loginId}`,
                method: 'GET',
            })
        }),
        pbiUpdateUserDetails: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/userprofile`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiExportFile: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/ExportFile`,
                method: 'POST',
                body: { ...credentials },
                responseHandler: ((response) => response.blob()),
            })
        }),
        pbiGetReportPermission: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/UserReportPermission/${credentials.userID}/report/${credentials.reportId}`,
                method: 'GET',
            })
        }),
        pbiUpdateReportPermission: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/UserReportPermission`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiDeleteReport: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Report/${credentials.reportId}/workspace/${credentials.workspaceId}`,
                method: 'DELETE',
            })
        }),
        pbiGetSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/subscriptions?username=${credentials.loginId}`,
                method: 'GET',
            })
        }),
        pbiCreateSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/create_subscription`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiEditSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/edit_subscription`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiDeleteSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/delete_subscription`, ///${credentials.id}
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiEnableSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/enable_subscription/${credentials.id}`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiDisableSubscriptions: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/subscription-management/disable_subscription/${credentials.id}`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiFolder: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/folder`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiGetFolders: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/folder/user/${credentials.userID}`,
                method: 'GET',
            })
        }),
        pbiMoveFolderReport: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/folder/move/report`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiMoveFolder: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/folder/move`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiPasteReport: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Report/Clone`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiAdminUserAccess: builder.mutation({
            query: credentials => ({
                url: `${BASE_URL}/authentication/canEditReportPermission`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiDeleteFolder: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Folder/Delete`,
                method: 'DELETE',
                body: { ...credentials },
            })
        }),
        pbiGetAllUsers: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/UserProfile/workspace/${credentials.wsid}`,
                method: 'GET',
            })
        }),
        pbiGetRefreshSession: builder.mutation({
            query: () => ({
                url: `${BASE_URL}/authentication/keep-alive-endpoint`,
                method: 'GET',
            })
        }),
        pbiManualRefresh: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/DatasetRefresh/RefreshDatasets`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiManualRefreshStatus: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/DatasetRefresh/RefreshDatasetsHistory`,
                method: 'POST',
                body: { ...credentials },
            })
        }),
        pbiClearCacheData: builder.mutation({
            query: credentials => ({
                url: `${DOTNET_BASE_URL}/Report/ClearCache/workspace/${credentials}`,
                method: 'GET',
            })
        }),
    })
})

export const {
    useLoginMutation,
    useLogoutMutation,
    usePbiLoginMutation,
    usePbiReportListMutation,
    usePbiReportListWithFolderMutation,
    usePbiReportDetailsMutation,
    usePbiGetTenantDetailsMutation,
    usePbiGetUserDetailsMutation,
    usePbiUpdateUserDetailsMutation,
    usePbiExportFileMutation,
    usePbiGetReportPermissionMutation,
    usePbiUpdateReportPermissionMutation,
    usePbiDeleteReportMutation,
    usePbiGetSubscriptionsMutation,
    usePbiCreateSubscriptionsMutation,
    usePbiEditSubscriptionsMutation,
    usePbiDeleteSubscriptionsMutation,
    usePbiEnableSubscriptionsMutation,
    usePbiDisableSubscriptionsMutation,
    usePbiFolderMutation,
    usePbiGetFoldersMutation,
    usePbiMoveFolderReportMutation,
    usePbiMoveFolderMutation,
    usePbiMoveReportMutation,
    usePbiAdminUserAccessMutation,
    usePbiDeleteFolderMutation,
    usePbiGetAllUsersMutation,
    usePbiGetRefreshSessionMutation,
    usePbiManualRefreshMutation,
    usePbiManualRefreshStatusMutation,
    usePbiClearCacheDataMutation,
} = authApiSlice